import { inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ComparatorOperators, ExportRisksCatalogueGQL, ExportRisksCatalogueMutation, GetRiskCatalogueGQL, GetRiskCatalogueQuery, OperatorInput, OrderTypeInput, RiskCatalogueTreeColumns, RiskCatalogueTreeQueryComplexInput, RiskCatalogueTreeSimpleQueryInput, RiskCatalogueTreeSortInput, RiskQueryComplexInput, RiskSortInput } from "../../../graphql/generated";


@Injectable({
    providedIn: 'root'
})

export class RiskCatalogueService {
    private readonly GetRiskCatalogueGQL: GetRiskCatalogueGQL = inject(GetRiskCatalogueGQL);
    private readonly ExportRisksCatalogueGQL: ExportRisksCatalogueGQL = inject(ExportRisksCatalogueGQL);

    getRiskCatalogue(parameters: any): Observable<GetRiskCatalogueQuery['riskCatalogueTree']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.GetRiskCatalogueGQL.fetch({ query: param.query as RiskCatalogueTreeQueryComplexInput, sort: param.sort as RiskCatalogueTreeSortInput }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.riskCatalogueTree))
    }

    exportRiskCatalogue(parameters: any, timeZone: string): Observable<ExportRisksCatalogueMutation['downloadRiskCatalogueByQuery']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.ExportRisksCatalogueGQL.mutate({ query: param.query as RiskCatalogueTreeQueryComplexInput, sort: param.sort as RiskCatalogueTreeSortInput, timeZone }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data?.downloadRiskCatalogueByQuery));
    }

    async downloadFile(response: string, fileName: string | undefined) {
        const typeFormat = {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        };
        const link = window.document.createElement("a");
        const blob = this.base64ToBlob(response, typeFormat.type); // Cambia il tipo MIME
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName ?? "fileExport";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
    }

    private base64ToBlob(base64: string, mimeType: string): Blob {
        const byteChars = atob(base64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    }
}

export function convertLazyLoadToComplexWithoutPage(parameters: any): {
    query: RiskCatalogueTreeQueryComplexInput
    sort: RiskCatalogueTreeSortInput
} {
    const query: RiskCatalogueTreeSimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_RISK_CATALOGUE[field as keyof typeof ENUM_RISK_CATALOGUE] || [field]).forEach(key => {
                        query.push({
                            field: key as RiskCatalogueTreeColumns,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: values
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.And
                }
            ]
        },
        sort: {
            sortField: ENUM_RISK_CATALOGUE?.[parameters?.order?.sortField as keyof typeof ENUM_RISK_CATALOGUE]?.[0] as RiskCatalogueTreeColumns || RiskCatalogueTreeColumns.Code,
            sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc
        }
    }
}

export const ENUM_RISK_CATALOGUE = {
    category: [RiskCatalogueTreeColumns.Category],
    code: [RiskCatalogueTreeColumns.Code],
    name: [RiskCatalogueTreeColumns.Name],
    status: [RiskCatalogueTreeColumns.Status],
    description: [RiskCatalogueTreeColumns.Description],
    example: [RiskCatalogueTreeColumns.Examples]
}